import React from 'react';
import './App.css';
import Shell from './components/Shell';
import { ScorecardProvider } from './components/ScorecardContext';

export default function App() {
  return (
    <ScorecardProvider>
      <Shell />
    </ScorecardProvider>
  );
}
